// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1HIvj","colMin":"styles_colMin__23nnl","colCheckbox":"styles_colCheckbox__1_R7G"};